import { createNgReactBridgeDirective } from '../../react-bridge'
import { YourKeys } from '../../../components/keys-settings/your-keys'

export const yourKeys = createNgReactBridgeDirective(
  'reactYourKeys',
  [],
  YourKeys,
  [
    'role',
    'apiKey',
    'organization',
    'contrastURL',
    'serviceKey',
    'authHeader',
    'onRotateServiceKey',
    'onCopyAuthHeader',
    'onCopyAPIRequest'
  ]
)
